const defaultState = {
	plants: [],
	msgTypes: [],
	langs: [],
	msgLocs: [],
	msgId: [],
	gridMsgID: [],
	gridMsgTypes: [],
	gridMsgLocs: [],
	searchParams: {
		plantCd: '',
		msgKey: null,
		msgText: null,
		msgType: 'ALL',
		msgLoc: 'ALL'
	},
	dicMsgManagements: [],
	groups: {
		currentPage: 1,
		pageUnit: 30,
		totalSize: 0
	}
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
